export const testimonials = [
  {
    id: 1,
    name: 'Alexandra & James Whitfield',
    location: 'Henderson, NV',
    project: 'Full Living Room & Dining Room',
    rating: 5,
    text: 'We furnished our entire open-concept living and dining space through Eclectic Home. The design team was phenomenal — they helped us find pieces that felt cohesive, personal, and genuinely luxurious. Every guest comments on how beautiful it looks.',
    date: 'February 2026',
  },
  {
    id: 2,
    name: 'Sophia Chen',
    location: 'Summerlin, NV',
    project: 'Master Bedroom Suite',
    rating: 5,
    text: 'The Oslo Platform Bed is the most beautiful piece of furniture I\'ve ever owned. The quality far exceeds anything I\'d seen at other stores. Delivery was white-glove and flawless. I\'m already planning my next purchase.',
    date: 'January 2026',
  },
  {
    id: 3,
    name: 'Marcus & Priya Delacroix',
    location: 'Las Vegas, NV',
    project: 'Home Office & Library',
    rating: 5,
    text: 'I needed a home office that matched the sophistication of my clients\' expectations. Eclectic Home delivered — the Summit Desk and custom built-in shelving is a showstopper. The team\'s design eye is genuinely exceptional.',
    date: 'December 2025',
  },
  {
    id: 4,
    name: 'Caroline Fontaine',
    location: 'Paradise, NV',
    project: 'Dining Room Transformation',
    rating: 5,
    text: 'The Navarra Dining Table is simply stunning. Solid oak, hand-finished, and the quality is something you can feel immediately. The showroom experience was unlike any furniture shopping I\'ve done — relaxed, informed, zero pressure.',
    date: 'November 2025',
  },
  {
    id: 5,
    name: 'David & Elena Hartwell',
    location: 'Green Valley, NV',
    project: 'Full Home Furnishing',
    rating: 5,
    text: 'We furnished our new build entirely through Eclectic Home. The team managed a complex project with impeccable taste. Every room feels intentional, curated, and authentically us. Worth every penny — this is how furniture shopping should feel.',
    date: 'October 2025',
  },
];
